/* MV Sortiment assets/mv-sortiment.et2.js - Paket E-T2 - 2026-10-13
 *
 * Original-Ersatzteile "auf Anfrage" (Inhaberentscheid 13.10.2026; Doku _docs/et2-anfrage-teile.md, Tests
 * _tests/et2-anfrage-teile.test.mjs). Drei Aufgaben, je ohne Abhaengigkeit von anderen Teilen des Buendels:
 *  1. Teile-Sektion (sections/mv-ersatzteile.liquid, [data-mv-ersatzteile]):
 *     a) Nachladen: traegt die Sektion data-mv-et2-nachladen (collection.products kann bestellbare Teile abgeschnitten
 *        haben), holt das Skript dieselbe Seite mit ?view=teile-karten (templates/collection.teile-karten.liquid,
 *        paginate mit 250 je Seite; Sortierung, Tag-Seite und Vorschau-Parameter bleiben, automat/kategorie/q/page
 *        nicht) und ordnet die Karten ein: bestellbare ins Raster [data-mv-teile-raster] in der Reihenfolge der Seite
 *        (Standard: Kollektion, dann Fenster-Produkte; Preis auf- bzw. absteigend: nach data-mv-et2-preis), Anfrage-Teile
 *        (data-mv-et2-gruppe anfrage) ans Ende der Gruppe [data-mv-et2-raster="anfrage"] bzw. ohne Gruppe ans Ende des
 *        Rasters. Vorhandene Karten bleiben (gleicher Handle = gleiches Element). Danach liest der Teile-Finder die Karten
 *        neu (window.__mvSortiment.teile.init(), assets/mv-sortiment.teile.js: Zaehler, Filter, Suche), der Hinweis
 *        .mv-ersatzteile__mehr verschwindet; data-mv-et2-geladen = laeuft | ja | fehler. Ohne fetch/DOMParser oder bei
 *        einem Fehler bleibt die Seite, wie der Server sie liefert (mit Hinweis).
 *     b) Gruppen: blendet die Gruppe [data-mv-et2-gruppe] und das Label [data-mv-et2-label] aus, solange der Filter
 *        (Mein Automat, Kacheln, Suche) dort keine Karte zeigt (MutationObserver auf hidden der Zellen).
 *  2. Kaufbox der Vorlage product.anfrage (snippets/mv-anfrage-kaufbox.liquid): beim Klick auf "Teil anfragen"
 *     ([data-mv-et2-teil], Phase capture, also vor dem Oeffner-Skript der Lightbox) haengt das Skript ausgefuellte
 *     Bestell-Eigenschaften ([data-mv-eig-name] in snippets/mv-eigenschaften.liquid) an data-teil an.
 *  3. Warenkorb-Schutz: Formulare mit data-mv-et2-gesperrt (Schutz in snippets/buy-buttons.liquid) und Formulare an
 *     /cart/add mit einer Variante aus [data-mv-et2-varianten] (Kaufbox der Anfrage-Teile) werden nie abgeschickt
 *     (submit, Phase capture, vor Impacts product-form). Serverseitig schuetzt DENY (Katalog Paket E-K4b).
 * Teil von assets/mv-sortiment.js (_build/konkat.sh), laedt allein und in beliebiger Reihenfolge, defer-faehig; der
 * Teile-Finder wird erst nach dem Nachladen angesprochen. Unter Node (Tests) liefert die Datei nur die reinen
 * Funktionen ueber module.exports. Kommentare ASCII; sichtbare Texte keine (nur Daten der Seite).
 */
;(function () {
  'use strict';

  var VERSION = '2026-10-13.1';
  var ANSICHT = 'teile-karten';
  var MAX_TEIL = 200;
  var MAX_SEITEN = 8;
  var TRENNER = ' · ';

  // ===========================================================================================
  // Teil 1: reine Logik
  // ===========================================================================================

  // Wert eines Query-Parameters (null, wenn er fehlt)
  function parameter(suche, name) {
    var s = String(suche || '');
    if (s.charAt(0) === '?') s = s.slice(1);
    var paare = s.split('&');
    for (var i = 0; i < paare.length; i++) {
      if (!paare[i]) continue;
      var gleich = paare[i].indexOf('=');
      var k = gleich === -1 ? paare[i] : paare[i].slice(0, gleich);
      var v = gleich === -1 ? '' : paare[i].slice(gleich + 1);
      try {
        k = decodeURIComponent(k.replace(/\+/g, ' '));
        v = decodeURIComponent(v.replace(/\+/g, ' '));
      } catch (e) {
        continue;
      }
      if (k === name) return v;
    }
    return null;
  }

  // Adresse der Nachladeansicht: Pfad der Seite (Kollektion oder Tag-Seite), fremde Parameter in ihrer Reihenfolge
  // (sort_by, preview_theme_id), ohne Filter des Teile-Finders (automat, kategorie, q), ohne page und view, ohne Hash;
  // dazu view=teile-karten und bei Seite > 1 page=<seite>
  function nachladeUrl(href, seite) {
    var s = String(href || '');
    var h = s.indexOf('#');
    if (h !== -1) s = s.slice(0, h);
    var q = s.indexOf('?');
    var pfad = q === -1 ? s : s.slice(0, q);
    var teile = q === -1 ? [] : s.slice(q + 1).split('&').filter(function (p) {
      var name = p.split('=')[0];
      return p && ['automat', 'kategorie', 'q', 'page', 'view'].indexOf(name) === -1;
    });
    teile.push('view=' + ANSICHT);
    var n = parseInt(seite, 10);
    if (n > 1) teile.push('page=' + n);
    return pfad + '?' + teile.join('&');
  }

  // Sortierung der Seite: price-ascending, price-descending oder '' (Kollektionsreihenfolge)
  function sortierungVon(suche) {
    var s = String(parameter(suche, 'sort_by') || '');
    return s === 'price-ascending' || s === 'price-descending' ? s : '';
  }

  function zahl(x) {
    var n = parseInt(x, 10);
    return isNaN(n) ? 0 : n;
  }

  // Neue Reihenfolge der bestellbaren Karten. vorhanden: Karten im Raster [{handle, preis, quelle}] in ihrer
  // Reihenfolge; geladen: Karten der Nachladeansicht [{handle, preis, gruppe}] in deren Reihenfolge (= Reihenfolge der
  // Kollektion fuer die Sortierung der Seite). Ergebnis { bestellbar: [handle...], anfrage: [handle...] }:
  // Standard - erst die geladenen bestellbaren, dann vorhandene, die nicht geladen wurden (Fenster-Produkte); Preis -
  // dieselbe Liste stabil nach Preis. anfrage: geladene Anfrage-Teile, die es auf der Seite noch nicht gibt.
  function ordnen(vorhanden, geladen, sortierung, sonstVorhanden) {
    var da = {};
    var schon = {};
    var liste = [];
    var anfrage = [];
    (sonstVorhanden || []).forEach(function (h) { schon[h] = true; });
    (geladen || []).forEach(function (k) {
      if (!k || !k.handle || da[k.handle]) return;
      da[k.handle] = true;
      if (k.gruppe === 'anfrage') {
        if (!schon[k.handle]) anfrage.push(k.handle);
        return;
      }
      liste.push({ handle: k.handle, preis: zahl(k.preis), rang: liste.length });
    });
    (vorhanden || []).forEach(function (k) {
      if (!k || !k.handle || da[k.handle]) return;
      da[k.handle] = true;
      liste.push({ handle: k.handle, preis: zahl(k.preis), rang: 100000 + liste.length });
    });
    if (sortierung === 'price-ascending' || sortierung === 'price-descending') {
      var auf = sortierung === 'price-ascending';
      liste.sort(function (a, b) {
        if (a.preis !== b.preis) return auf ? a.preis - b.preis : b.preis - a.preis;
        return a.rang - b.rang;
      });
    }
    return { bestellbar: liste.map(function (k) { return k.handle; }), anfrage: anfrage };
  }

  // Text fuer contact[Teil]: Grundtext der Kaufbox, dazu ausgefuellte Bestell-Eigenschaften "Name: Wert" (Mittelpunkt
  // als Trenner), Leerraum zusammengefasst, hoechstens 200 Zeichen
  function teilMitEigenschaften(basis, paare) {
    var t = String(basis || '').replace(/\s+/g, ' ').replace(/^ | $/g, '');
    (paare || []).forEach(function (p) {
      if (!p) return;
      var name = String(p.name || '').replace(/\s+/g, ' ').replace(/^ | $/g, '');
      var wert = String(p.wert || '').replace(/\s+/g, ' ').replace(/^ | $/g, '');
      if (!name || !wert) return;
      t += (t ? TRENNER : '') + name + ': ' + wert;
    });
    return t.slice(0, MAX_TEIL);
  }

  // Name einer Bestell-Eigenschaft aus dem Feldnamen properties[<Name>]
  function eigenschaftName(feldname) {
    var m = /^properties\[(.*)\]$/.exec(String(feldname || ''));
    return m ? m[1] : '';
  }

  // Variantennummern aus data-mv-et2-varianten (mit Leerzeichen getrennt)
  function variantenAus(text) {
    return String(text || '').split(/\s+/).filter(function (x) { return /^\d+$/.test(x); });
  }

  var logik = {
    VERSION: VERSION,
    ANSICHT: ANSICHT,
    parameter: parameter,
    nachladeUrl: nachladeUrl,
    sortierungVon: sortierungVon,
    ordnen: ordnen,
    teilMitEigenschaften: teilMitEigenschaften,
    eigenschaftName: eigenschaftName,
    variantenAus: variantenAus
  };

  if (typeof window === 'undefined' || typeof document === 'undefined') {
    if (typeof module === 'object' && module && module.exports) module.exports = logik;
    return;
  }

  // ===========================================================================================
  // Teil 2: Browser
  // ===========================================================================================

  var MV = window.__mvSortiment = window.__mvSortiment || {};
  if (MV.et2) return;

  function alle(selektor, wurzel) {
    return Array.prototype.slice.call((wurzel || document).querySelectorAll(selektor));
  }

  // ---------- 2. Kaufbox: Bestell-Eigenschaften an data-teil ----------

  document.addEventListener('click', function (e) {
    var knopf = e.target && e.target.closest ? e.target.closest('[data-mv-et2-teil]') : null;
    if (!knopf) return;
    var bereich = knopf.closest('.product-info') || knopf.closest('form') || document;
    var paare = alle('[data-mv-eigenschaften] [data-mv-eig-name]', bereich).map(function (f) {
      return { name: eigenschaftName(f.getAttribute('name')) || f.getAttribute('data-mv-eig-name'), wert: f.value };
    });
    knopf.setAttribute('data-teil', teilMitEigenschaften(knopf.getAttribute('data-mv-et2-teil'), paare));
  }, true);

  // ---------- 3. Warenkorb-Schutz ----------

  function anfrageVarianten() {
    var ids = {};
    alle('[data-mv-et2-varianten]').forEach(function (el) {
      variantenAus(el.getAttribute('data-mv-et2-varianten')).forEach(function (id) { ids[id] = true; });
    });
    return ids;
  }

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || f.tagName !== 'FORM') return;
    var gesperrt = f.hasAttribute('data-mv-et2-gesperrt');
    if (!gesperrt && /\/cart\/add/.test(f.getAttribute('action') || '')) {
      var id = f.elements && f.elements.id ? f.elements.id.value : '';
      gesperrt = !!(id && anfrageVarianten()[String(id)]);
    }
    if (!gesperrt) return;
    e.preventDefault();
    e.stopImmediatePropagation();
  }, true);

  // ---------- 1b. Gruppen der Teile-Sektion ----------

  function sichtbareZellen(liste) {
    return liste ? alle('[data-mv-teile-zelle]', liste).filter(function (z) { return !z.hidden; }).length : 0;
  }

  function gruppenZeichnen(wurzel) {
    var raster = wurzel.querySelector('[data-mv-teile-raster]');
    var label = wurzel.querySelector('[data-mv-et2-label]');
    if (label) label.hidden = sichtbareZellen(raster) === 0;
    alle('[data-mv-et2-gruppe]', wurzel).forEach(function (g) {
      if (g.tagName === 'LI') return;
      g.hidden = sichtbareZellen(g.querySelector('[data-mv-et2-raster]')) === 0;
    });
  }

  function beobachten(wurzel) {
    if (wurzel.__mvEt2Beobachtet || typeof window.MutationObserver !== 'function') return;
    wurzel.__mvEt2Beobachtet = true;
    var geplant = false;
    new window.MutationObserver(function () {
      if (geplant) return;
      geplant = true;
      window.setTimeout(function () {
        geplant = false;
        gruppenZeichnen(wurzel);
      }, 0);
    }).observe(wurzel, { subtree: true, childList: true, attributes: true, attributeFilter: ['hidden'] });
  }

  // ---------- 1a. Nachladen ----------

  function karteVon(zelle) {
    var k = zelle.querySelector('[data-mv-teil]');
    return k ? k.getAttribute('data-mv-teil') : '';
  }

  // Eine Antwort der Nachladeansicht lesen: { zellen: [li...], seiten } oder null (keine Liste)
  function lesen(html) {
    var doc = new window.DOMParser().parseFromString(String(html || ''), 'text/html');
    var liste = doc.querySelector('[data-mv-et2-teile-karten]');
    if (!liste) return null;
    return { zellen: alle('[data-mv-teile-zelle]', liste), seiten: parseInt(liste.getAttribute('data-mv-et2-seiten'), 10) || 1 };
  }

  // Alle geladenen Zellen (Seiten in ihrer Reihenfolge) einmal einordnen
  function einordnen(wurzel, geladeneZellen) {
    var raster = wurzel.querySelector('[data-mv-teile-raster]');
    if (!raster) return false;
    var gruppe = wurzel.querySelector('[data-mv-et2-raster="anfrage"]');
    var zellen = {};
    var vorhanden = alle('[data-mv-teile-zelle]', raster).map(function (z) {
      var h = karteVon(z);
      if (h) zellen[h] = z;
      return { handle: h, preis: z.getAttribute('data-mv-et2-preis'), quelle: z.getAttribute('data-mv-et2-quelle') };
    });
    var sonst = gruppe ? alle('[data-mv-teile-zelle]', gruppe).map(karteVon) : [];
    var neu = {};
    var geladen = geladeneZellen.map(function (z) {
      var h = karteVon(z);
      if (h && !zellen[h] && !neu[h]) neu[h] = z;
      return { handle: h, preis: z.getAttribute('data-mv-et2-preis'), gruppe: z.getAttribute('data-mv-et2-gruppe') };
    });
    var plan = ordnen(vorhanden, geladen, sortierungVon(window.location.search), sonst);
    plan.bestellbar.forEach(function (h) {
      var z = zellen[h] || (neu[h] ? document.importNode(neu[h], true) : null);
      if (z) raster.appendChild(z);
    });
    plan.anfrage.forEach(function (h) {
      if (neu[h]) (gruppe || raster).appendChild(document.importNode(neu[h], true));
    });
    return true;
  }

  function holen(url) {
    return window.fetch(url, { credentials: 'same-origin', headers: { Accept: 'text/html' } }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.text();
    }).then(function (html) {
      var erg = lesen(html);
      if (!erg) throw new Error('Nachladeansicht ohne Liste');
      return erg;
    });
  }

  function fertig(wurzel, ok) {
    wurzel.setAttribute('data-mv-et2-geladen', ok ? 'ja' : 'fehler');
    if (!ok) return;
    alle('.mv-ersatzteile__mehr', wurzel).forEach(function (p) { p.hidden = true; });
    var teile = MV.teile;
    if (teile && typeof teile.init === 'function') teile.init();
    gruppenZeichnen(wurzel);
  }

  function nachladen(wurzel) {
    if (!wurzel.hasAttribute('data-mv-et2-nachladen') || wurzel.hasAttribute('data-mv-et2-geladen')) return;
    if (typeof window.fetch !== 'function' || typeof window.DOMParser !== 'function') return;
    wurzel.setAttribute('data-mv-et2-geladen', 'laeuft');
    var href = window.location.pathname + window.location.search;
    var gesammelt = [];
    holen(nachladeUrl(href, 1)).then(function (erste) {
      gesammelt = gesammelt.concat(erste.zellen);
      var weitere = [];
      for (var s = 2; s <= Math.min(erste.seiten, MAX_SEITEN); s++) weitere.push(s);
      return weitere.reduce(function (kette, s) {
        return kette.then(function () { return holen(nachladeUrl(href, s)); }).then(function (erg) { gesammelt = gesammelt.concat(erg.zellen); });
      }, Promise.resolve());
    }).then(function () {
      if (!einordnen(wurzel, gesammelt)) throw new Error('Raster fehlt');
      fertig(wurzel, true);
    }).catch(function () {
      fertig(wurzel, false);
    });
  }

  function starten() {
    alle('[data-mv-ersatzteile]').forEach(function (w) {
      beobachten(w);
      gruppenZeichnen(w);
      nachladen(w);
    });
  }

  document.addEventListener('shopify:section:load', starten);

  MV.et2 = { version: VERSION, logik: logik, init: starten };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', starten);
  else starten();
})();
